import { ReactNode } from 'react';
import { closeSnackbar, SnackbarProvider } from 'notistack';
import { ReactComponent as CloseIco } from '../../assets/svg/utils/close.svg';

interface SnackbarProps {
  children: ReactNode;
}

function CloseBtn(snackbarId: string) {
  return (
    <button
      type="button"
      className="mr-2"
      onClick={() => closeSnackbar(snackbarId)}
    >
      <CloseIco className="stroke-[#ffffff]" />
    </button>
  );
}

function Snackbar({ children }: SnackbarProps) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={CloseBtn}
      autoHideDuration={7000}
      hideIconVariant
      className="SnackbarProviderOvveride"
      classes={{
        containerRoot: 'SnackbarContainerRootOverrride',
      }}
    >
      {children}
    </SnackbarProvider>
  );
}

export default Snackbar;
